import type { BoardBuilderDurationStatProjections } from '@library/types/boardBuilder';
import type { LeagueProjectionAttributes } from '@library/types/leagues';
import type { Updater } from 'use-immer';

export const populatePropjectionsRank = ({
  confirmedStatTypes,
  durations,
  startRank,
  setDurationStatProjections
}: {
  confirmedStatTypes: Array<string>;
  durations: Array<LeagueProjectionAttributes>;
  startRank: number;
  setDurationStatProjections: Updater<BoardBuilderDurationStatProjections>;
}) => {
  setDurationStatProjections((draft) => {
    durations.forEach((duration) => {
      confirmedStatTypes.forEach((statType) => {
        const durationStatProjections =
          draft[duration.leagueProjectionFilterId]?.statTypes[statType]
            ?.projections;

        if (!durationStatProjections || durationStatProjections.length <= 0) {
          return;
        }
        let rank = startRank;
        durationStatProjections.forEach((_projection, index) => {
          durationStatProjections[index].rank = rank;
          rank += 1;
        });
      });
    });
  });
};
